import * as z from 'zod'

import {AssetSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/asset'
import {FormSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/form'
import {PrimerComponentCardSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentCard'
import {PrimerComponentProseSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentProse'
import {PrimerComponentHeroSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentHero'
import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {RichTextSchema} from '@github-ui/swp-core/schemas/contentful/richText'
import {GenericCallToActionSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/genericCallToAction'
import {IndexFilterSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/indexTemplate'
import {PersonSchema} from './person'

export const TemplateResourceDetailsSchema = buildEntrySchemaFor('templateResourceDetails', {
  fields: z.lazy(() =>
    z.object({
      hero: PrimerComponentHeroSchema.optional(),
      featuredImage: AssetSchema.optional(),
      lede: RichTextSchema.optional(),
      body: PrimerComponentProseSchema.optional(),
      tableOfContents: z.boolean().optional(),
      featuredCta: GenericCallToActionSchema.optional(),
      form: FormSchema.optional(),
      peopleLabel: z.string().optional(),
      people: z.array(PersonSchema).optional(),
      tags: z.array(IndexFilterSchema).optional(),
      tagsLabel: z.string().optional(),
      relatedResources: z.array(PrimerComponentCardSchema).optional(),
    }),
  ),
})

export type ResourceDetailsPage = z.infer<typeof TemplateResourceDetailsSchema>
